import { render, staticRenderFns } from "./TablePermissionChanged.vue?vue&type=template&id=84b9cf30"
import script from "./TablePermissionChanged.vue?vue&type=script&lang=js"
export * from "./TablePermissionChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports